(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pmg-ambassador-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var TOTAL = 3;

    function initForm(root) {
      if (!root || root.dataset.pmgFormInit === 'true') return;

      var panels = root.querySelectorAll('[data-pmg-panel]');
      if (!panels.length) return;

      var counter = root.querySelector('[data-pmg-counter]');
      var fill = root.querySelector('.pmg-apply__progress-fill');
      var backBtn = root.querySelector('[data-pmg-back]');
      var nextBtn = root.querySelector('[data-pmg-next]');
      var submitBtn = root.querySelector('[data-pmg-submit]');
      var honeypot = root.querySelector('#PmgApplyCompany');
      var form = root.closest('form');

      // A server-side error round-trip lands the applicant back on the step
      // that holds it rather than at the start.
      var current = parseInt(root.dataset.pmgErrorStep, 10) || 1;

      function panelAt(n) {
        return root.querySelector('[data-pmg-panel="' + n + '"]');
      }

      function clearError(field) {
        var box = field.parentNode.querySelector('[data-pmg-error]');
        field.removeAttribute('aria-invalid');
        if (box) {
          box.hidden = true;
          box.textContent = '';
        }
      }

      function showError(field, message) {
        var box = field.parentNode.querySelector('[data-pmg-error]');
        field.setAttribute('aria-invalid', 'true');
        if (box) {
          box.textContent = message;
          box.hidden = false;
          if (box.id) field.setAttribute('aria-describedby', box.id);
        }
      }

      // Validates the current panel only. Fields on the other panels are
      // still in the DOM, so validating the whole form here would report
      // errors the applicant cannot see yet.
      function validatePanel(n) {
        var panel = panelAt(n);
        var fields = panel.querySelectorAll('input, select, textarea');
        var firstBad = null;

        for (var i = 0; i < fields.length; i++) {
          var field = fields[i];
          clearError(field);
          if (!field.checkValidity()) {
            showError(field, field.validationMessage);
            if (!firstBad) firstBad = field;
          }
        }

        if (firstBad) {
          firstBad.focus();
          return false;
        }
        return true;
      }

      // Attempt log for the mirror, kept so a device that reported a missing
      // row can be read directly. CORS means the browser never sees the
      // response, so this records what was attempted, not what arrived. The
      // Log sheet is the other half of that pair. Outcome and timestamp only.
      // No applicant field value goes in here.
      var CRUMB_KEY = 'pmg.ambassador.mirror';
      var CRUMB_MAX = 20;

      function breadcrumb(outcome) {
        try {
          var store = window.localStorage;
          if (!store) return;
          var log = JSON.parse(store.getItem(CRUMB_KEY) || '[]');
          if (!Array.isArray(log)) log = [];
          log.push({ t: new Date().toISOString(), outcome: outcome });
          if (log.length > CRUMB_MAX) log = log.slice(-CRUMB_MAX);
          store.setItem(CRUMB_KEY, JSON.stringify(log));
        } catch (error) {
          // Deliberately empty. Private browsing and a full quota both throw
          // here, and neither is a reason to disturb the submit.
        }
      }

      // Secondary mirror of the application to a Google Sheet. Everything in
      // here is best effort. It never calls preventDefault, never awaits, and
      // the caller swallows anything it throws, because an exception raised
      // inside a submit handler can abort the native POST and turn a
      // nice-to-have into a lost application.
      function mirrorToSheet(suppressedReason) {
        var endpoint = root.dataset.pmgSheetUrl;
        // No endpoint configured means no mirror, and the form behaves exactly
        // as it did before this existed.
        if (!endpoint) {
          breadcrumb('no-endpoint');
          return;
        }
        // One row per page life. A second submit event cannot write a second.
        // A suppressed report carries its own flag so that reporting a guard
        // rejection cannot consume the slot a later real submit needs.
        var onceFlag = suppressedReason ? 'pmgSheetSuppressed' : 'pmgSheetSent';
        if (root.dataset[onceFlag] === 'true') {
          breadcrumb('duplicate');
          return;
        }
        root.dataset[onceFlag] = 'true';

        function valueOf(id) {
          var field = root.querySelector('#' + id);
          return field ? field.value : '';
        }

        // Keys are fixed by the Apps Script FIELD_MAP and are not the
        // contact[...] names on the form. Anything not in this list is ignored
        // by the script.
        var payload = {
          secret: root.dataset.pmgSheetSecret || '',
          name: valueOf('PmgApplyName'),
          email: valueOf('PmgApplyEmail'),
          level: valueOf('PmgApplyLevel'),
          school: valueOf('PmgApplyClub'),
          social: valueOf('PmgApplyHandle'),
          // position is a legacy payload key retained deliberately. It went
          // dead when Position was removed and it now carries glove size.
          // Renaming it means editing FIELD_MAP in the Apps Script and
          // redeploying, and a redeploy issues a new /exec URL unless it is
          // published as a new version of the existing deployment. A silent
          // URL change stops rows arriving while the form still looks fine.
          // The Sheet header is renamed to "Glove size" instead. Do not
          // rename this key without also updating the script.
          position: valueOf('PmgApplyGloveSize'),
          source: 'password-page',
          ua: navigator.userAgent,
          honeypot: valueOf('PmgApplyCompany')
        };

        // A guard that rejects a submission still tells the endpoint it
        // happened. The endpoint writes the report to the Log sheet and not to
        // Sheet1, so behaviour is unchanged and a false positive stops being
        // invisible. Before this, a rejection left no trace anywhere.
        if (suppressedReason) {
          payload.suppressed = 1;
          payload.reason = suppressedReason;
        }

        var body = JSON.stringify(payload);

        // sendBeacon is the load-bearing choice. The native submit navigates
        // away and a plain fetch dies with the document, so the mirror would
        // fail intermittently and still look fine in testing. text/plain keeps
        // this a simple request, because an application/json content type
        // triggers a preflight and Apps Script does not answer preflight.
        var sent = false;
        var outcome = 'beacon';
        try {
          if (navigator.sendBeacon) {
            sent = navigator.sendBeacon(endpoint, new Blob([body], { type: 'text/plain;charset=UTF-8' }));
          }
        } catch (error) {
          // Some engines throw here rather than returning false when they
          // refuse to queue. Without this the exception escaped to the caller,
          // whose catch is empty, and the fallback below never ran.
          sent = false;
        }

        // keepalive is what lets the fallback survive the same navigation.
        if (!sent) {
          outcome = 'fetch-fallback';
          try {
            fetch(endpoint, {
              method: 'POST',
              mode: 'no-cors',
              keepalive: true,
              headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
              body: body
            }).catch(function () {});
          } catch (error) {
            outcome = 'failed';
          }
        }

        // sendBeacon returning true means queued, not delivered, so this is a
        // record of the attempt and never proof of a write. The Log sheet is
        // what confirms arrival.
        breadcrumb(suppressedReason ? outcome + ':suppressed:' + suppressedReason : outcome);
      }

      function render() {
        for (var n = 1; n <= TOTAL; n++) {
          var panel = panelAt(n);
          if (!panel) continue;
          // hidden plus the display rule in CSS, so a closed panel leaves
          // the tab order rather than just going invisible.
          panel.hidden = n !== current;
        }

        if (counter) counter.textContent = 'Step ' + current + ' of ' + TOTAL;
        if (fill) fill.style.setProperty('--pmg-apply-progress', (current / TOTAL) * 100 + '%');

        if (backBtn) backBtn.style.display = current === 1 ? 'none' : '';
        if (nextBtn) nextBtn.style.display = current === TOTAL ? 'none' : '';
        if (submitBtn) submitBtn.style.display = current === TOTAL ? '' : 'none';
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          if (!validatePanel(current)) return;
          if (current < TOTAL) {
            current += 1;
            render();
            var legend = panelAt(current).querySelector('.pmg-apply__legend');
            if (legend) {
              legend.setAttribute('tabindex', '-1');
              legend.focus();
            }
          }
        });
      }

      // Back never re-validates. Going backwards to fix something should
      // not be blocked by the thing being fixed.
      if (backBtn) {
        backBtn.addEventListener('click', function () {
          if (current > 1) {
            current -= 1;
            render();
          }
        });
      }

      if (form) {
        form.addEventListener('submit', function (event) {
          if (honeypot && honeypot.value !== '') {
            event.preventDefault();
            // Report the rejection before returning. The endpoint decides
            // whether it becomes a row, and a false positive from autofill now
            // leaves a trace instead of disappearing.
            try {
              mirrorToSheet('honeypot');
            } catch (error) {
              // Deliberately empty. Reporting a rejection must not throw.
            }
            return;
          }
          // Guard the whole form on the real submit, and surface the step
          // holding the first problem.
          for (var n = 1; n <= TOTAL; n++) {
            var panel = panelAt(n);
            var fields = panel.querySelectorAll('input, select, textarea');
            for (var i = 0; i < fields.length; i++) {
              if (!fields[i].checkValidity()) {
                event.preventDefault();
                current = n;
                render();
                validatePanel(n);
                return;
              }
            }
          }

          // Validation has passed and the native POST is about to go. Fire the
          // mirror and let the submit continue untouched.
          try {
            mirrorToSheet();
          } catch (error) {
            // Deliberately empty. A mirror failure must never reach the submit.
          }
        });
      }

      root.dataset.pmgFormInit = 'true';
      render();
    }

    function initAll(scope) {
      var nodes = (scope || document).querySelectorAll('[data-pmg-form]');
      for (var i = 0; i < nodes.length; i++) initForm(nodes[i]);
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pmg-clip"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initClip(root) {
      if (!root || root.dataset.pmgClipInit === 'true') return;
      var video = root.querySelector('video');
      if (!video) return;

      var playBtn = root.querySelector('.pmg-clip__play');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // Belt and braces: video_tag builds the element, so the inline
      // playback flags are reasserted here. iOS refuses inline autoplay
      // without both of these.
      video.muted = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');

      function doPlay() {
        var p = video.play();
        if (p && p.then) {
          p.then(function () { root.classList.remove('is-paused'); }).catch(function () {});
        }
      }

      video.addEventListener('play', function () { root.classList.remove('is-paused'); });
      if (playBtn) playBtn.addEventListener('click', doPlay);
      video.addEventListener('click', function () {
        if (video.paused) doPlay();
      });

      root.dataset.pmgClipInit = 'true';

      if (reduce) {
        // Hold the poster still and let the visitor start it by hand.
        video.removeAttribute('autoplay');
        video.autoplay = false;
        try {
          video.pause();
          video.currentTime = 0;
        } catch (e) {}
        root.classList.add('is-paused');
        return;
      }

      var attempt = video.play();
      if (attempt && attempt.catch) {
        attempt.catch(function () { root.classList.add('is-paused'); });
      }
    }

    function initAll(scope) {
      var nodes = (scope || document).querySelectorAll('[data-pmg-clip]');
      for (var i = 0; i < nodes.length; i++) initClip(nodes[i]);
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pmg-collection-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGrid(root) {
      if (!root) return;
      var track = root.querySelector('[data-pmg-grid-track]');
      if (!track) return;
      var dots = root.querySelectorAll('[data-pmg-grid-dot]');
      var slides = track.querySelectorAll('[data-pmg-grid-slide]');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      /* Dots appear only when the row does not already fit. The community
         carousel keys this off dot count, which would show dots for six
         cards on a wide desktop where nothing is hidden. Overflow is the
         honest test. Re-evaluated on resize because the breakpoint changes
         how many cards fit. */
      function syncDots() {
        var overflows = track.scrollWidth > track.clientWidth + 1;
        if (overflows && dots.length > 1) {
          root.dataset.pmgGridInit = 'true';
        } else {
          delete root.dataset.pmgGridInit;
        }
      }

      function setActive(active) {
        for (var i = 0; i < dots.length; i++) {
          dots[i].setAttribute('aria-current', i === active ? 'true' : 'false');
        }
      }

      if (root.dataset.pmgGridBound !== 'true') {
        for (var d = 0; d < dots.length; d++) {
          dots[d].addEventListener('click', function () {
            var idx = parseInt(this.getAttribute('data-pmg-grid-dot'), 10);
            var slide = slides[idx];
            if (!slide) return;
            slide.scrollIntoView({
              behavior: reduce ? 'auto' : 'smooth',
              inline: 'start',
              block: 'nearest'
            });
          });
        }

        if ('IntersectionObserver' in window) {
          var ratios = {};
          var observer = new IntersectionObserver(function (entries) {
            for (var e = 0; e < entries.length; e++) {
              var idx = parseInt(entries[e].target.getAttribute('data-index'), 10);
              if (!isNaN(idx)) ratios[idx] = entries[e].intersectionRatio;
            }
            var best = 0;
            var bestRatio = -1;
            var keys = Object.keys(ratios);
            for (var k = 0; k < keys.length; k++) {
              var key = parseInt(keys[k], 10);
              if (ratios[key] > bestRatio) {
                bestRatio = ratios[key];
                best = key;
              }
            }
            setActive(best);
          }, { root: track, threshold: [0.25, 0.5, 0.75, 1] });

          for (var s = 0; s < slides.length; s++) observer.observe(slides[s]);
        }

        window.addEventListener('resize', syncDots, { passive: true });
        root.dataset.pmgGridBound = 'true';
      }

      setActive(0);
      syncDots();
    }

    function initAll(scope) {
      var nodes = (scope || document).querySelectorAll('[data-pmg-grid]');
      for (var i = 0; i < nodes.length; i++) initGrid(nodes[i]);
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pmg-community-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCommunity(root) {
      if (!root || root.dataset.pmgCommunityInit === 'true') return;
      var track = root.querySelector('[data-pmg-community-track]');
      var dots = root.querySelectorAll('[data-pmg-community-dot]');
      if (!track || dots.length < 2) return;

      var slides = track.querySelectorAll('[data-pmg-community-slide]');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function setActive(active) {
        for (var i = 0; i < dots.length; i++) {
          dots[i].setAttribute('aria-current', i === active ? 'true' : 'false');
        }
      }

      for (var d = 0; d < dots.length; d++) {
        dots[d].addEventListener('click', function () {
          var idx = parseInt(this.getAttribute('data-pmg-community-dot'), 10);
          var slide = slides[idx];
          if (!slide) return;
          slide.scrollIntoView({
            behavior: reduce ? 'auto' : 'smooth',
            inline: 'start',
            block: 'nearest'
          });
        });
      }

      if ('IntersectionObserver' in window) {
        var ratios = {};
        var observer = new IntersectionObserver(function (entries) {
          for (var e = 0; e < entries.length; e++) {
            var idx = parseInt(entries[e].target.getAttribute('data-index'), 10);
            if (!isNaN(idx)) ratios[idx] = entries[e].intersectionRatio;
          }
          var best = 0;
          var bestRatio = -1;
          var keys = Object.keys(ratios);
          for (var k = 0; k < keys.length; k++) {
            var key = parseInt(keys[k], 10);
            if (ratios[key] > bestRatio) {
              bestRatio = ratios[key];
              best = key;
            }
          }
          setActive(best);
        }, { root: track, threshold: [0.25, 0.5, 0.75, 1] });

        for (var s = 0; s < slides.length; s++) {
          observer.observe(slides[s]);
        }
      }

      setActive(0);
      root.dataset.pmgCommunityInit = 'true';
    }

    function initAll(scope) {
      var nodes = (scope || document).querySelectorAll('[data-pmg-community]');
      for (var i = 0; i < nodes.length; i++) initCommunity(nodes[i]);
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pmg-hero-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHero(root) {
      if (!root || root.dataset.pmgHerovidInit === 'true') return;
      var video = root.querySelector('video');
      if (!video) return;
      root.dataset.pmgHerovidInit = 'true';

      // video_tag builds the element, so the inline playback flags are
      // reasserted here. iOS silently refuses autoplay when muted is not set
      // on the element itself.
      video.muted = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        // Hold the poster. load() restores it after a browser-started autoplay.
        video.removeAttribute('autoplay');
        video.autoplay = false;
        try {
          video.pause();
          video.load();
        } catch (e) {}
        return;
      }

      // Retry once now that muted is guaranteed. A rejection is fine: the
      // poster holds with the overlay on top, which is the intended fallback.
      var attempt = video.play();
      if (attempt && attempt.catch) attempt.catch(function () {});
    }

    function initAll(scope) {
      var nodes = (scope || document).querySelectorAll('[data-pmg-herovid]');
      for (var i = 0; i < nodes.length; i++) initHero(nodes[i]);
    }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', function () { initAll(); });

    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pmg-password-landing"] && !Shopify.designMode) return;
  try {
    
  // The inline script in the lockup snippet is the primary init. It runs
  // during parse, before first paint, which is what removes the flash.
  // Section re-render in the editor swaps markup in as innerHTML and
  // innerHTML never executes inline scripts, so the flag is reapplied here
  // for that case alone.
  document.addEventListener('shopify:section:load', function (event) {
    var nodes = event.target.querySelectorAll('.pmg-lockup--anim');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].setAttribute('data-pmg-lockup-init', 'true');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
